<template>
  <div class="h-full flex flex-col">
    <!--<div>
      <o-scroll
        class="flex overflow-x-auto overflow-y-hidden relative flex-row border-b border-gray-200"
        :class="[
          navClass
        ]"
        :y-axis="false"
        :x-axis="true"
      >
        <span
          class="absolute h-2px bottom-0 bg-blue-600 shadow transition-all ease-in-out duration-200"
          :style="underline"
        />

        <template v-for="(section, index) in sections" :key="index">
          <button
            v-if="section.visible == undefined || section.visible"

            :ref="'button-' + index"
            class="flex h-8 flex-shrink-0 items-center text-gray-600 text-sm mr-2 md:mr-6 -mb-px px-2 leading-none hover:text-blue-600 focus:outline-none"
            :class="[
              { 'text-blue-600 font-medium' : active === index },
            ]"
            @click="move(index)"
          >
            <o-icon v-if="section.icon" :icon="section.icon" class="lg:mr-3 p-2 md:p-0" />
            <span class="hidden lg:block">{{ section.name }}</span>
          </button>
        </template>
      </o-scroll>
    </div>-->

    <div
      class="flex-shrink h-10 flex-row border-b border-gray-200 dark:border-gray-800"
      :class="navClass"
    >
      <o-scroll x-axis :y-axis="false">
        <div
          class="flex overflow-x-auto overflow-y-hidden relative h-full items-center"
        >
          <span
            class="absolute h-px bottom-0 bg-blue-600 shadow transition-all ease-in-out duration-200"
            :style="underline"
          />
          <template v-for="(section, index) in sections" :key="index">
            <button
              v-if="section.visible == undefined || section.visible"

              :ref="el => { if (el) buttonRefs['button-' + index] = el }"
              class="flex h-8 flex-shrink-0 items-center text-gray-600 text-sm mr-2 md:mr-6 -mb-px px-2 leading-none hover:text-blue-600 focus:outline-none"
              :class="[
                { 'text-blue-600 font-medium' : active === index },
              ]"
              @click="move(index)"
            >
              <o-icon v-if="section.icon" :icon="section.icon" class="lg:mr-3 p-2 md:p-0" />
              <span class="hidden lg:block">{{ section.name }}</span>
            </button>
          </template>
        </div>
      </o-scroll>
    </div>

    <o-scroll ref="scrollRef" class="flex-grow flex-shrink w-full h-full overflow-y-auto text-secondary" @onScroll="onScroll">
      <div ref="sectionsEl" class="divide-y divide-gray-200">
        <slot />
      </div>
    </o-scroll>
  </div>
</template>

<script setup lang="ts">
import type { SectionRegistration } from './Section.vue'

interface Props {
  navClass?: string
}

withDefaults(defineProps<Props>(), {
  navClass: '',
})

const active = ref(0)
const underline = ref<Record<string, string>>({})
const scrollRef = ref<any>()
const sectionsEl = ref<HTMLElement>()
const buttonRefs = ref<Record<string, any>>({})
const registeredSections = ref<SectionRegistration[]>([])

// Provide register/unregister functions for child Section components
provide('scrollspy-register', (section: SectionRegistration) => {
  registeredSections.value.push(section)
})

provide('scrollspy-unregister', (section: SectionRegistration) => {
  const index = registeredSections.value.indexOf(section)
  if (index > -1) {
    registeredSections.value.splice(index, 1)
  }
})

const sections = computed(() => {
  return registeredSections.value
})

const offsets = computed(() => {
  const elements = sectionsEl.value?.children
  const result: number[] = []

  if (elements) {
    for (let i = 0; i < elements.length; i++) {
      const offset = (elements[i] as HTMLElement).offsetTop
      if (offset >= 0) {
        result.push(offset)
      }
    }
  }

  return result
})

watch(active, () => {
  calc()
})

onMounted(() => {
  calc()
})

function select(index: number) {
  active.value = index
}

function onScroll(val: any) {
  const scrollTop = val.target.scrollTop
  const offset = 0
  const position = scrollTop + offset
  let i = 0
  while (position >= offsets.value[i]) { i++ }
  active.value = (i ? i - 1 : 0)
}

function move(index: number) {
  const section = sections.value[index]
  if (section?.el) {
    section.el.scrollIntoView()
  }
}

function calc() {
  const activeBtn = buttonRefs.value['button-' + active.value]

  if (activeBtn) {
    const el = activeBtn as HTMLElement
    const left = el.offsetLeft + 'px'
    const width = el.getBoundingClientRect().width + 'px'
    underline.value = { left, width }
  }
}
</script>
